<template>
  <van-popup
    v-model="show"
    closeable
    round
    position="bottom"
    @close="close"
    :style="defaultPhoneHeight < 600 ? { height: '90%' } : { height: '600px' }"
  >
    <div class="box-main">
      <div class="box-top">取消寄件</div>
      <div style="font-size:14px;color:#7f7f7f">请告诉我们取消寄件的原因：</div>
      <!-- <div class="cancelReason" ref="reason"> -->
      <van-radio-group
        v-model="current"
        checked-color="#a30015"
        @change="change"
      >
        <van-radio
          v-for="(item, index) in radioList"
          :key="index"
          :name="index"
          class="radio-list"
          ref="radio"
          :style="index === radioList.length - 1 ? 'margin-bottom:10px' : ''"
          >{{ item }}</van-radio
        >
      </van-radio-group>
      <!-- </div> -->
      <div class="otherBox" v-show="current === 9">
        <input
          type="text"
          v-model="other"
          maxlength="55"
          placeholder="请输入原因"
          class="otherType"
        />
        <span class="valueLength">{{ other.length + '/55' }}</span>
      </div>
    </div>
    <div
      class="footer flex"
      :style="defaultPhoneHeight < 600 ? '' : 'position:fixed'"
      v-show="!focus"
    >
      <div class="cancel-btn flex" @click="handleCancel">暂不取消</div>
      <div class="confirm-btn flex" @click="handleComfirm">确定取消</div>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: ['orderInfo'],
  data() {
    return {
      show: false,
      current: null,
      radioList: [
        '计划有变，不需要寄了',
        '下单信息有误，需要修改',
        '想选择其他方式寄件',
        '工作人员引导取消',
        '距离太远了/找不到服务网点',
        '服务网点环境差',
        '服务网点态度差',
        '运费太贵了',
        '不符合寄件标准(如贵品、大件、违禁品等)',
        '其他'
      ],
      other: '',
      selected: null,
      cancelReason: '',
      defaultPhoneHeight: 0, // 屏幕默认高度
      nowPhoneHeight: 0, // 屏幕现在的高度
      focus: false
    }
  },
  watch: {
    nowPhoneHeight: function() {
      if (this.defaultPhoneHeight !== this.nowPhoneHeight) {
        // 手机键盘被唤起了。
        this.focus = true
      } else {
        // 手机键盘被关闭了。
        this.focus = false
      }
    }
  },
  mounted() {
    this.defaultPhoneHeight = window.innerHeight
    window.onresize = () => {
      this.nowPhoneHeight = window.innerHeight
    }
  },
  methods: {
    handleShow(item) {
      //   console.log(item)
      this.show = true
      this.current = null
    },
    close() {
      this.$emit('close')
    },
    change(e) {
      this.selected = e
    },
    handleCancel() {
      this.show = false
    },
    handleComfirm() {
      if (this.selected === null) {
        this.$notify({
          message: '请选择原因',
          type: 'danger'
        })
        return
      }
      if (this.selected !== this.radioList.length - 1) {
        this.cancelReason = this.radioList[this.selected]
      } else {
        if (this.other === '') {
          this.$notify({
            message: '请输入原因',
            type: 'danger'
          })
          return
        }
        this.cancelReason = this.other
      }
      let params = {
        orderId: this.orderInfo.orderId,
        cancelReason: this.cancelReason
      }
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api.cancelOrder(data).then(res => {
        if (res.code === 0) {
          this.$notify({
            message: '取消成功',
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.handleCancel()
              this.$emit('refresh')
            }
          })
        } else {
          this.$toast.fail(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.box-main {
  padding: 15px;
  .box-top {
    margin: 0 0 5px;
  }
  .radio-list {
    margin: 20px 10px;
    font-size: 14px;
  }
}
.otherBox {
  position: relative;
  display: flex;
  border: none;
  padding: 0 5px;
  width: 100%;
  font-size: 14px;
  .valueLength {
    position: absolute;
    bottom: 0.4em;
    right: 0.5em;
  }
}
.otherType {
  flex: 1;
  //   width: 100%;
  border: 1px solid #e4b3b9;
  border-radius: 3px;
  padding: 0.4em;
  padding-right: 60px;
  resize: none;
}
.footer {
  position: sticky;
  bottom: 0;
  // justify-content: space-around;
  width: 100vw;
  text-align: center;
  padding-bottom: 10px;
  background-color: #fff;
  .cancel-btn,
  .confirm-btn {
    width: 45vw;
    height: 44px;
    border-radius: 22px;
  }
  .cancel-btn {
    color: #fff;
    background-color: #a30014;
    margin-right: 5vw;
  }
  .confirm-btn {
    border: 1px solid #ccc;
  }
}
</style>
